import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import _, { get as _get } from 'lodash-es';
import { sorting } from './Constants';

class ProductSort extends React.Component {
  static defaultProps = {
    sorting: sorting,
  };
  constructor(props) {
    super(props);
    let sortingAttributes = Object.keys(this.props.sorting);
    if (this.props.isCollection)
      sortingAttributes = sortingAttributes.filter(
        each => each != 'compatioscore_descending'
      );
    else {
      sortingAttributes = sortingAttributes.filter(
        each =>
          each != 'date_ascending' &&
          each != 'date_descending' &&
          each != 'best_selling'
      );
    }
    this.state = {
      sortingAttributes: sortingAttributes,
      sorting: this.props.sorting,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    if (event.target.value !== 'default') {
      const sortOrder = event.target.value;
      this.props.handleChangeSortOrder(sortOrder);
    }
  }

  render() {
    let optionList = [];
    if (this.props.isCollection)
      optionList.push(
        <option key="default" value="default">
          Select Sorting Option
        </option>
      );
      this.state.sortingAttributes.forEach(key => {
        const labelText = this.props.intl.formatMessage({
          id: `ProductSort.sorting.${key}`,
          defaultMessage: this.state.sorting[key].label,
        });
        optionList.push(
          <option key={key} value={key}>
            {labelText}
          </option>
        );
      });

    return (
      <div className="xrs-products__sort">
        <label>
          <FormattedMessage
            id="ProductSort.sort_by_label"
            defaultMessage="Sort by:"
          />
          <select
            value={this.props.currentSortOrder}
            onChange={this.handleChange}
            data-testid="product_sort_select"
          >
            {optionList}
          </select>
        </label>
      </div>
    );
  }
}

export default injectIntl(ProductSort);
